/**
 * Selects selected filing period
 * @param {Object} savedFilingPeriod - SavedFilingPeriod state slice.
 * @returns {*}
 */
import { type SelectedFiling } from '@api/savedFilingPeriod/types';
import { type RootState } from '@store/types';

export const selectedFilingPeriodSelector = (
  { savedFilingPeriod = {} } = {} as RootState
): SelectedFiling => savedFilingPeriod.selected;
